<div class="container" aria-modal="true">
  <div mat-dialog-title class="dialog-title">
    @if (editingUser) {
      <h1 mat-dialog-title>Edit {{data.user_type}}</h1>
    }
    @if (!editingUser) {
      <h1 mat-dialog-title>Add New {{data.user_type}}</h1>
    }
    <button mat-icon-button aria-label="close dialog" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  @if (enteringEmail) {
    <mat-dialog-content>
      <div class="title_light">Enter user’s email address to verify if user exists in user roster:</div>
      <mat-form-field appearance="outline" class="fullsize">
        <mat-label>Email Address</mat-label>
        <input [formControl]="emailInput" pattern="[a-zA-Z0-9._%+\-]+&#64;[a-z0-9.\-]+\.[a-z]{2,3}$" matInput
          required cdkFocusInitial placeholder="e.g. john.watson@usda.gov" (keyup.enter)="checkIfUserExist()"
          (input)="emailInputChanged()">
          <mat-error>Please enter a valid email</mat-error>
        </mat-form-field>
        @if (foundUser && canEdit) {
          <div class="green-box">
            <div class="container_message">
              <div class="subcontainer_message">
                <i class="material-icons check-icon">check_circle</i>
                <div>
                  <span class="title">
                    <b>{{foundUser.first_name}} {{foundUser.last_name}} ({{emailInput.value}})</b> already
                    exists in user roster and is
                    @if (!foundUser.region) {
                      <span><b>unassigned</b></span>
                    }
                    @if (foundUser.region) {
                      <span> currently assigned to <b>Region {{foundUser.region}}</b>
                      @if (foundUser.forest_name) {
                        <span> and <b>{{foundUser.forest_name}}</b></span>
                      }
                    </span>
                    }. Select <b>'Continue'</b> to edit this user's
                    details.
                  </span>
                </div>
              </div>
            </div>
          </div>
        }
        @if (foundUser && !canEdit) {
          <div class="yellow-box">
            <div class="container_message">
              <div class="subcontainer_message">
                <i class="material-icons check-icon">warning</i>
                <div>
                  <span class="title">
                    <b>{{foundUser.first_name}} {{foundUser.last_name}} ({{emailInput.value}})</b> is currently
                    assigned to <b>Region {{foundUser.region}}</b>@if (foundUser.forest_name) {
                    <span> and
                      <b>{{foundUser.forest_name}}</b></span>
                      }. If the user needs to be added to your forest,
                      request them to update their location instead.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          }
        </mat-dialog-content>
      }
      @if (!enteringEmail) {
        <mat-dialog-content>
          <form id="filter_form" class="filter_form" [formGroup]="userForm">
            <div class="subtitle"><span class="red">*</span>Indicates required field</div>
            <div class="title-form">USER DETAILS</div>
            <mat-form-field appearance="outline">
              <mat-label>First Name</mat-label>
              <input matInput formControlName="first_name" required cdkFocusInitial>
              <mat-error>Required Field</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Last Name</mat-label>
              <input matInput formControlName="last_name" required cdkFocusInitial>
              <mat-error>Required Field</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Email Address</mat-label>
              <input matInput formControlName="email" required cdkFocusInitial>
              <mat-error>Required Field</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="half-form">
              <mat-label>Phone Number</mat-label>
              <input matInput formControlName="phone_num" cdkFocusInitial placeholder="(XXX) XXX-XXXX"
                mask="(000) 000-0000">
              </mat-form-field>
              @if (data.user_type == 'User') {
                <mat-form-field appearance="outline">
                  <mat-label>Agency</mat-label>
                  <mat-select formControlName="agency_id" required
                    (selectionChange)="updateValidators($event.value, 'agency_id')">
                    @for (agency of agency_list; track agency_list) {
                      <mat-option [value]="agency.value">{{agency.text}}</mat-option>
                    }
                  </mat-select>
                  <mat-error>Required Field</mat-error>
                </mat-form-field>
              }
              <div class="location-info">
                @if ((userForm.controls['agency_id'].getRawValue() ?? 0) == 0) {
                  <div class="subtitle">
                    <span class="red">*</span><b>Organizational Unit Location</b>
                  </div>
                }
                @if ((userForm.controls['agency_id'].getRawValue() ?? 0) != 0) {
                  <div class="title-form">Location
                    <span class="gray-text">(Closest Forest Service Office)</span>
                  </div>
                }
                <mat-radio-group required formControlName="location_id" class="radio-buttons"
                  (change)="updateValidators($event.value, 'location_id')">
                  <mat-radio-button [value]="0" color="primary" class="radio-button">Forest Office</mat-radio-button>
                  <mat-radio-button [value]="1" color="primary">Regional Office</mat-radio-button>
                  @if (userForm.controls['agency_id'].getRawValue() == 0) {
                    <mat-radio-button [value]="2" color="primary"
                    >Washington Office</mat-radio-button>
                  }
                </mat-radio-group>
                @if (userForm.controls['location_id'].getRawValue() == 0 || userForm.controls['location_id'].getRawValue() == 1) {
                  <div class="sub-location"
                    >
                    <mat-form-field appearance="outline">
                      <mat-label>Region</mat-label>
                      <mat-select formControlName="region" required (selectionChange)="regionChanged()">
                        @for (region of regions; track region) {
                          <mat-option [value]="region">{{region}}</mat-option>
                        }
                      </mat-select>
                      <mat-error>Required Field</mat-error>
                    </mat-form-field>
                    @if (userForm.controls['location_id'].getRawValue() == 0) {
                      <mat-form-field appearance="outline"
                        style="width: 50%">
                        <mat-label>Forest Name</mat-label>
                        <input #forest matInput required formControlName="forest_name" [matAutocomplete]="auto"
                          (input)="filter()" (focus)="clearForest()">
                          <mat-autocomplete requireSelection #auto="matAutocomplete"
                            (optionSelected)="forestNameSelected($event)">
                            @for (name of filtered_forest_names | async; track name) {
                              <mat-option [value]="name">{{name | forest_filter}}</mat-option>
                            }
                          </mat-autocomplete>
                          <mat-error>Required Field</mat-error>
                        </mat-form-field>
                      }
                    </div>
                  }
                </div>
                @if ((userForm.controls['agency_id'].getRawValue() ?? 0) == 0) {
                  <div class="location-info">
                    <div class="subtitle" style="margin-top: 10px;">
                      <span class="red">*</span><b>Duty Station Location</b>
                    </div>
                    <mat-radio-group required formControlName="duty_location_id" class="radio-buttons"
                      (change)="updateValidators($event.value, 'duty_location_id')">
                      <mat-radio-button [value]="0" color="primary" class="radio-button">Forest Office</mat-radio-button>
                      <mat-radio-button [value]="1" color="primary">Regional Office</mat-radio-button>
                      @if (userForm.controls['agency_id'].getRawValue() == 0) {
                        <mat-radio-button [value]="2" color="primary"
                        >Washington Office</mat-radio-button>
                      }
                    </mat-radio-group>
                    @if (userForm.controls['duty_location_id'].getRawValue() == 0 || userForm.controls['duty_location_id'].getRawValue() == 1) {
                      <div class="sub-location"
                        >
                        <mat-form-field appearance="outline">
                          <mat-label>Region</mat-label>
                          <mat-select formControlName="duty_region" required (selectionChange)="regionChanged_duty()">
                            @for (region of regions; track region) {
                              <mat-option [value]="region">{{region}}</mat-option>
                            }
                          </mat-select>
                          <mat-error>Required Field</mat-error>
                        </mat-form-field>
                        @if (userForm.controls['duty_location_id'].getRawValue() == 0) {
                          <mat-form-field appearance="outline"
                            style="width: 50%">
                            <mat-label>Forest Name</mat-label>
                            <input #forest matInput required formControlName="duty_forest_name" [matAutocomplete]="auto"
                              (input)="filter_duty()" (focus)="clearForest_duty()">
                              <mat-autocomplete requireSelection #auto="matAutocomplete"
                                (optionSelected)="forestNameSelected_duty($event)">
                                @for (name of filtered_forest_names_duty | async; track name) {
                                  <mat-option [value]="name">{{name | forest_filter}}</mat-option>
                                }
                              </mat-autocomplete>
                              <mat-error>Required Field</mat-error>
                            </mat-form-field>
                          }
                        </div>
                      }
                    </div>
                  }
                  @if (data.user_type == 'Coordinator' || data.user_type == 'Line Officer') {
                    <div class="positions">
                      <div class="title-form">POSITIONS<button class="usa-button usa-button--secondary"
                        (click)="addPosition()">
                        <fa-icon [icon]="faPlus"></fa-icon>Add Position
                      </button></div>
                      @for (position of PositionList; track position; let i = $index) {
                        @if ((PositionList.length > 1) || data.user_type == 'Coordinator') {
                          <button class="position-remove" (click)="removePosition(position.item)"
                            matTooltip="Remove" matTooltipClass="tooltipClass">
                            <mat-icon>close</mat-icon>
                          </button>
                        }
                        <app-location-filter [(location)]='PositionList[i]' [regions]='regions' [roles]="roles"
                          [user_type]="data.user_type" [BAER_role_type]="BAER_role_type"
                          [org_location]="userForm.controls['location_id'].getRawValue()"
                          [org_region]="userForm.controls['region'].getRawValue()"
                          [org_forest]="userForm.controls['forest_name'].getRawValue()"
                          [duty_location]="userForm.controls['duty_location_id'].getRawValue()"
                          [duty_region]="userForm.controls['duty_region'].getRawValue()"
                        [duty_forest]="userForm.controls['duty_forest_name'].getRawValue()"></app-location-filter>
                      }
                    </div>
                  }
                </form>
              </mat-dialog-content>
            }
            <div mat-dialog-actions>
              <div class="button-row">
                <button class="usa-button usa-button--secondary" mat-dialog-close>Cancel</button>
                @if (!enteringEmail && editingUser) {
                  <button class="usa-button"
                  [disabled]="!userForm.valid || !positionsValid" (click)="saveUser()">Update</button>
                }
                @if (!enteringEmail && !editingUser) {
                  <button class="usa-button" [disabled]="!userForm.valid"
                  (click)="saveUser()">Save</button>
                }
                @if (enteringEmail) {
                  <button class="usa-button" [disabled]="!emailInput.valid || !canEdit"
                    (click)="checkIfUserExist()">Continue <i class="material-icons">chevron_right</i></button>
                  }
                </div>
              </div>
            </div>
